import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

// context

// components
import { StyledText, Back } from "../../../components/common/basic";
import DetailsCard from "../../../components/common/detailsCard";

// data
import {
  mtnpulseTNC,
  captuenshareTNC,
  mashupWinTNC,
  speedshoppingTNC,
  pulsechillTNC,
  blackStarsQatar,
  blackpanthertriviaTNC,
  seasonofsurprisesTNC,
  afconQualifiersTNC,
  asafotufiamTNC,
  pulseTriviTnC,
  pulseSpinTheWheeltnc,
} from "./";
import { Privacy } from "../../../components/common";

const Terms = () => {
  const history = useHistory();

  const [currentTerm, setCurrentTerm] = useState(null);

  const terms = {
    mtnpulse: mtnpulseTNC,
    captureshare: captuenshareTNC,
    mashupwin: mashupWinTNC,
    speedshopping: speedshoppingTNC,
    pulsechill: pulsechillTNC,
    blackStarsQatar: blackStarsQatar,
    blackpanther: blackpanthertriviaTNC,
    seasonofsurprises: seasonofsurprisesTNC,
    afconQualifiers: afconQualifiersTNC,
    asafotufiam: asafotufiamTNC,
    pulseTrivia: pulseTriviTnC,
    spinTheWheel: pulseSpinTheWheeltnc,
  };

  return (
    <>
      {true && (
        <Back
          onClick={() => {
            if (currentTerm) {
              setCurrentTerm(null);
            } else {
              history.goBack();
            }
          }}
        >
          <FontAwesomeIcon
            style={{ alignSelf: "center", justifySelf: "center" }}
            color={"white"}
            icon={faChevronLeft}
          />
          <StyledText color={"white"}>Back</StyledText>
        </Back>
      )}
      {currentTerm ? (
        <Privacy currentTerm={currentTerm} />
      ) : (
        <>
          <StyledText align={"center"}>Our Legal Terms of Use</StyledText>
          <DetailsCard
            title={"MTN Pulse"}
            details={"Privacy Policy"}
            action={"Read"}
            onClick={() => {
              setCurrentTerm(terms["mtnpulse"]);
            }}
          />
          <DetailsCard
            title={"Capture & Share"}
            details={"General Terms"}
            action={"Read"}
            onClick={() => {
              setCurrentTerm(terms["captureshare"]);
            }}
          />
          <DetailsCard
            title={"Mashup & Win"}
            details={"Terms and Condition"}
            action={"Read"}
            onClick={() => {
              setCurrentTerm(terms["mashupwin"]);
            }}
          />
          <DetailsCard
            title={"Speed Shopping"}
            details={"Terms and Condition"}
            action={"Read"}
            onClick={() => {
              setCurrentTerm(terms["speedshopping"]);
            }}
          />
          <DetailsCard
            onClick={() => {
              setCurrentTerm(terms["pulsechill"]);
            }}
            title={"Pulse & Chill"}
            details={"Terms and Condition"}
            action={"Read"}
          />
          <DetailsCard
            onClick={() => {
              setCurrentTerm(terms["pulseTrivia"]);
            }}
            title={"Pulse Trivia"}
            details={"Terms and Condition"}
            action={"Read"}
          />
          <DetailsCard
            onClick={() => {
              setCurrentTerm(terms["spinTheWheel"]);
            }}
            title={"Spin The Wheel"}
            details={"Terms and Condition"}
            action={"Read"}
          />
        </>
      )}
    </>
  );
};

export default Terms;
